import request from "@/utils/axios";

export const getPassengnum = () => {
  return request({
    url: "/api/blade-jianshan/jspassengnum/front/page",
    method: "get",
  });
};

export const getGuides = (params) => {
  return request({
    url: "/api/cms/guides/front/child-list",
    method: "get",
    params,
  });
};
